import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useMediaQuery, useTheme } from "@mui/material";
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@mui/material/IconButton";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from '@mui/icons-material/Add';



const useStyles = makeStyles((theme: any) => ({
  dialogRoot: {
    position: "relative",
  },
  dialogTitleRoot: {
    "& .MuiTypography-h6": {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
  dialogActionsRoot: {
    padding: "16px 24px",
  },
}));

export interface IPostDialog {
  onClose?: any;
  dialogContent?: any;
  actionFunc?: any;
  open: boolean;
  title?: any;
  // headerContent?: any;
  addLoading: boolean;
  // maxWidth: string;
  handleOpenDialog:any;
}

const BootstrapDialogTitle = (props: any) => {
  //Props
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#fff" }} {...other}>
      {children}
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme: any) => theme.palette.grey[500],
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
  );
};

export default function PostDialog(props: IPostDialog) {
  //Props
  const {
    onClose,
    open,
    // headerContent,
    dialogContent,
    actionFunc,
    title,
    addLoading,
    handleOpenDialog,
  } = props;

  //redux

  //Hooks
  const theme = useTheme();
  const reduceWidth = useMediaQuery(theme.breakpoints.down("md"));
  const classes = useStyles();

  const handleCancel = () => {
    onClose();
  };

  return (
    <>
      <Box sx={{ flexGrow: 1, width: "100%" }}>
        <Button
          startIcon={<AddIcon />}
          variant="outlined"
          size="small"
          onClick={handleOpenDialog}
        >
          Nouveau
        </Button>
      </Box>
      <Dialog
        open={open}
        maxWidth="md"
        fullWidth={false}
        style={{
          userSelect: "none", // empêcher la selection du texte sur l'interface utilisateur de l'application
        }}
      >
        <Box component="form">
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleCancel}
          >
            <Typography variant="h6">{title}</Typography>
          </BootstrapDialogTitle>
          <DialogContent
            dividers
            style={{
              // padding: reduceWidth ? "10px 10px" : "30px 45px",
              height: "60vh",
              background: "#f4f4f7",
            }}
          >
            {/* {headerContent} */}
            {dialogContent}
          </DialogContent>
          <DialogActions style={{margin:10}}>
            <LoadingButton
              loadingPosition="end"
              loading={addLoading}
              endIcon={<SaveIcon />}
              size="small"
              variant="contained"
              onClick={actionFunc}
              type="submit"
            >
              Enregistrer
            </LoadingButton>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
}
